import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";


const faqs = [
  {
    q: "How does Concord ensure only authorized users access sensitive documents?",
    a: "Concord's AI document management system policy engine enforces role-based access control automatically. Every user sees only what they are authorized to access.",
  },
  {
    q: "Can Concord handle documents across multiple departments and teams?",
    a: "Yes. Concord's modular architecture for document management is designed for both single teams and entire enterprises. Each department operates within its own governed space, while administrators maintain full visibility.",
  },
  {
    q: "How does the natural language search work in a document management system?",
    a: "Simply type your query in plain language, just as you would ask a colleague. Concord's AI understands the context and intent behind your request and retrieves the most relevant documents instantly.",
  },
  {
    q: "Does Concord integrate with our existing tools and infrastructure?",
    a: "Yes. Concord is built to work within your existing technology ecosystem. Our team works closely with your IT department to ensure seamless integration with your current storage systems, SSO providers, and enterprise infrastructure.",
  },
  {
    q: "How does an AI document management system improve workflow efficiency?",
    a: "An intelligent document control system eliminates manual access approvals, hours of document searching, and unsecured file sharing—replacing them with instant contextual retrieval, automated role-based permissions, and centralized secure collaboration.",
  },
];

const Section6 = () => {
   const [active, setActive] = useState(null);

  return (
    <section className="home-section-6">
  
        {/* FAQ */}
        <div className="faq-section">
          <div className="container">
  
            <h2 className="text-center">Frequently Asked Questions</h2>
  
            <div className="faq-list">
              {faqs.map((item, i) => (
                <div
                  key={i}
                  className={`faq-item ${active === i ? "active" : ""}`}
                  onClick={() => setActive(active === i ? null : i)}
                >
                  <div className="faq-question">
                    <span>{item.q}</span>
                    <FontAwesomeIcon icon={faChevronDown} />
                  </div>
  
                  <div className="faq-answer">
                    {item.a}
                  </div>
                </div>
              ))}
            </div>
  
          </div>
        </div>
  
        {/* CTA */}
        <div className="cta-section">
          <div className="container">
            <div className="cta-box text-center">
  
              <h2>Your Time Is Important. <br/>Waste Less on Managing Documents.</h2>
  
              <p>
                Transform your document management with AI-powered intelligent control. Get started today.
              </p>
  
              <button className="btn btn-light">Lets Get Started</button>
  
            </div>
          </div>
        </div>
  
    </section>
  );
};

export default Section6;
